// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b9c2dc68","239":"5daa0c23","453":"c4b57113","455":"2ede501b"}[chunkId] + ".chunk.js";
};